const COLORS = {
  primaryColor: '#7EB1AE',
  secondaryColor: '#FFD4BD',
  backgroundColor: '#FAF9F9',
};

export default COLORS;
